import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {ActiveCamera} from './active-camera.js';
import {LaughingManSequence} from './laughing-man-sequence.js';

const tempVec3Position = new Float32Array(3);
const tempVec3Forward = new Float32Array(3);

export class HeadDirectionTrigger extends Component {
    static TypeName = 'head-direction-trigger';

    @property.object()
    laughingManSquenceObject?: Object3D;

    @property.object()
    activeCameraObject?: Object3D;

    private activeCamera?: ActiveCamera;
    private laughingManSeq?: LaughingManSequence;
    private triggered = false;

    start() {
        if (!this.activeCameraObject) {
            throw new Error(
                `head-direction-trigger(${this.object.name}): activeCameraObject is not defined`
            );
        }
        const tempActiveCamera = this.activeCameraObject.getComponent(ActiveCamera);
        if (!tempActiveCamera) {
            throw new Error(
                `head-direction-trigger(${this.object.name}): activeCameraObject does not have a ActiveCamera component`
            );
        }
        this.activeCamera = tempActiveCamera;

        if (!this.laughingManSquenceObject) {
            throw new Error(
                `head-direction-trigger(${this.object.name}).laughingManSquenceObject is not defined`
            );
        }

        const tempLaughingManSeq =
            this.laughingManSquenceObject.getComponent(LaughingManSequence);
        if (!tempLaughingManSeq) {
            throw new Error(
                `head-direction-trigger(${this.object.name}): laughingManSquenceObject does not have a LaughingManSequence component`
            );
        }
        this.laughingManSeq = tempLaughingManSeq;
    }

    update() {
        if (this.triggered) {
            return;
        }
        const camera = this.activeCamera!.getActiveCamera();
        camera.getPositionWorld(tempVec3Position);
        camera.getForwardWorld(tempVec3Forward);
        const rayhit = this.engine.physics!.rayCast(
            tempVec3Position,
            tempVec3Forward,
            0b100000,
            5
        );
        if (rayhit && rayhit.hitCount > 0) {
            this.triggered = true;
            this.active = false;
            this.laughingManSeq!.active = true;
            this.laughingManSeq!.startSequence();
        }
    }
}
